export const SET_OPEN_BATTERY = 'open/SET_OPEN_BATTERY'